import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

import { SectionContainer } from "./SectionContainer";

// Handle general responsive padding
export const PaddedContainer = styled(SectionContainer)<{
  backgroundColor?: string;
  height?: string;
  largePaddingTop?: string;
}>`
  padding: ${Variables.space75};
  ${(props) =>
    props.backgroundColor ? `background-color: ${props.backgroundColor}` : ""};
  ${(props) => (props.height ? `height: ${props.height}` : "")};

  @media (min-width: ${Variables.breakpointM}) {
    padding: ${(props) =>
      props.largePaddingTop ? props.largePaddingTop : Variables.space150} ${
      Variables.space150
    }};
  }
`;
